export const DATE_COLUMNS = ['eventDate', 'createdAt', 'redeem.start', 'redeem.end']

export const NUMERIC_COLUMNS = ['benefit.cost', 'quantity', 'quantityAvailable']

export const PROXIMITY_SORT_COLUMNS = ['redeem.end', 'redeem.start']

export const COLUMN_MAPPING = {
  uf: 'region',
  type: 'tag',
  redeemStart: 'redeem.start',
  redeemEnd: 'redeem.end',
  tickets: 'quantityAvailable',
  points: 'benefit.cost'
}

export const SPECIAL_COLUMNS = {
  EDIT: 'edit'
}

export const EVENT_TYPE_FILTER = 'BATCHINSERT'
